/* Triggered on 'js-update-publish-as-options' select change */
/* Replaces publish-as (announcement_group) options based on selected location option dataset */

/* Expected dataset attribute on each location <option>: */
/* - announcementGroupOptions: JSON stringified array of [label, value] pairs */

$(document).on('change', '.js-update-publish-as-options', (e) => {
  const opt = e.currentTarget?.options[e.currentTarget?.selectedIndex];
  const wrapper = document.querySelector('.js-announcement-group-wrapper');
  const select = document.querySelector('.js-announcement-group-select');

  if (!opt || !wrapper || !select) return;

  const { announcementGroupOptions } = opt.dataset;
  if (announcementGroupOptions === undefined) return;

  const options = JSON.parse(announcementGroupOptions);
  const blankLabel = select.dataset.blankLabel || '';

  if (options.length === 0) {
    wrapper.classList.add('hidden');
    select.value = '';
    return;
  }

  wrapper.classList.remove('hidden');
  select.innerHTML = `<option value="">${blankLabel}</option>${options.map(([label, value]) => `<option value="${value}">${label}</option>`).join('')}`;
  select.value = '';
});
